export default "a50b40d7fb4f0e60.svg"